import { render, staticRenderFns } from "./CreateSeatingChart.vue?vue&type=template&id=34923d80"
import script from "./CreateSeatingChart.vue?vue&type=script&lang=js"
export * from "./CreateSeatingChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports